$.fn.prepareForm = function (locality) {
    /// <summary>Prepares a CAFM form for use, setting up controls and events</summary>
    /// <param name="locality" type="Object">Optional locality to prepare the form with</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function () {

        me = $(this);

        if (isNullOrUndefined(locality)) locality = cafm.forms.helpers.determineLocality();
        if (locality) cafm.forms.ensureDataLocalityId(locality, me);

        $('.cfLookup', me).setupLookup();
        $('input[data-fieldtype]', me).setupTextBoxes(); // setupTextBoxes ignores tri-state checkboxes which are setup later
        $('select', me).setupSelects(me);
        $('input[data-autocomplete]', me).setupAutoComplete(); // must be before $('#selector').setupEvents()
        $('[data-onfocus],[data-onblur],[data-onchange]:not([data-role="combobox"]),[data-onclick]', me[0]).setupEvents();
        $('input[type="checkbox"]', me).setupCheckbox();
        $('input[data-fieldtype="{0}"]'.format(cafm.enums.InputType.TriStateCheckbox), me).setupTriStateCheckbox();
        $('.elementState', me).setupElementState();
        $('.cfChkList', me).setupListSelectors(me);
        $('span[data-formatter]', me).formatInnerValue();
        $('.simpleList', me).setupBasicList();
        $('[data-default]', me).ensureDefaultValues();
        $('.makeCall', me).setupMakeCall();
        $('.mailTo', me).setupMailTo();
        $('[data-win-url]', me).setupWindow();

        $('.set-current-date-time', me).click(function (e) {

            $(e.currentTarget).closest('fieldset').getDateTimePickers().forEach(function (dtp) {
                dtp.value(cafm.web.funcs.getNowUTC());
                dtp.trigger('change');
            });
        });
    });
    return this;
}
$.fn.refreshForm = function () {
    /// <summary>Refreshes a CAFM form, re-setting up controls and events</summary>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function () {
        me = $(this);
        $('span[data-formatter]', me).formatInnerValue();
    });
    return this;
}
$.fn.validateElement = function () {

    var val = this.kendoValidator().data("kendoValidator");
    cafm.kendo.ext.validator.modify(val);
    return val && val.validate();
}
$.fn.clearValidateElements = function () {

    this.find('.k-invalid-msg').remove();
    this.find('.k-invalid').removeClass('k-invalid');
    return this;
}
$.fn.setupTextBoxes = function () {
    /// <summary>Sets up textboxes with advanced functionality.</summary>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function () {
        var me = $(this);
        var dt = me.data('fieldtype');
        if (dt && dt != cafm.enums.ControlType.TriStateCheckbox) {
            var opts = {
                culture: cafm.res.culture
            };
            var df = me.data('format');
            if (isDefined(df) && !isStr(df)) {
                df = new String(df);
            }

            if (!cafm.enums.isSingleEnumValue(dt, [cafm.enums.InputType.Date, cafm.enums.InputType.DateTime])) {

                // Need to remove these otherwise they get picked up in kendo numerictextbox triggering an issue.
                // For formats with zeros e.g. '00' it is treated as the number 0 internally in Kendo with error
                me.removeAttr('data-format');
                me.removeData('format');
                // -
            }

            var isIeMob = cafm.browsers.isIeMobile();

            // set spinners if specified -- applies to numeric textboxes 
            if (!isNullOrUndefined(me.data('spinners'))) opts.spinners = me.data('spinners');

            switch (dt) {
                case cafm.enums.InputType.Numeric:

                    opts.format = df;
                    opts.decimals = me.data('decimals');

                    var kNtB = me.kendoNumericTextBox(opts).data('kendoNumericTextBox'),
                        n = me.attr('id'),
                        ua = kNtB._upArrow,
                        da = kNtB._downArrow,
                        t = kNtB._text;

                    if (n) {

                        if (t && t.length) t.attr('id', '{0}_text'.format(n));
                        if (ua && ua.length) ua.attr('id', '{0}_upArrow'.format(n));
                        if (da && da.length) da.attr('id', '{0}_downArrow'.format(n));
                    }

                    break;

                case cafm.enums.InputType.Currency:

                    if (isUndefined(df)) {
                        opts.format = 'c';
                    }
                    else {
                        opts.format = df;
                    }
                    opts.decimals = me.data('decimals');
                    me.kendoNumericTextBox(opts);
                    break;

                case cafm.enums.InputType.Date:

                    if (isUndefined(df) || df != cafm.util.browserDateFormat()) {
                        df = cafm.util.browserDateFormat();
                        me.data('format', df);
                    }

                    let isMobOnDsk;
                    if (!isMobile || !cafm.browsers.supportsInput('date') || (isMobOnDsk = cafm.browsers.isMobileOnDesktop()) == true) {

                        if (isMobOnDsk) {
                            let db = me.attr("data-bind");
                            if (!isNullOrUndefined(db)) {
                                me.attr("data-bind", db.replace("dateValue", "value"));
                            }
                        }

                        me.kendoDatePicker(opts);

                        cafm.kendo.helpers.fixTodayOnDatePickerOpen(opts);

                        if (isIeMob) {

                            ieMobile.fixKendoDate({

                                widget: me.data('kendoDatePicker')
                            });
                        }
                    }

                    if (isMobile) {
                        me.val(cafm.util.ensureDate(me.val()));
                    }

                    break;

                case cafm.enums.InputType.DateTime:

                    if (isUndefined(df) || df != cafm.util.browserDateTimeFormat()) {
                        df = cafm.util.browserDateTimeFormat();
                        me.data('format', df);
                    }

                    if (!isMobile || !cafm.browsers.supportsInput('datetime-local') || cafm.browsers.isMobileOnDesktop()) {

                        me.kendoDateTimePicker(opts);

                        if (isIeMob) {

                            ieMobile.fixKendoDateTime({

                                widget: me.data('kendoDateTimePicker'),

                                relevance: function (e) {

                                    return e.view == 'time';
                                }
                            });
                        }

                        cafm.kendo.helpers.fixTodayOnDatePickerOpen(opts);

                    }
                    break;

                case cafm.enums.InputType.Time:

                    me.kendoTimePicker(opts);
                    break;
            }
        }
    });
    return this;
}
$.fn.setupSelects = function (parent) {
    this.each(function () {
        var me = $(this);
        var t = me.data('fieldtype');
        switch (t) {
            case cafm.enums.SelectType.Dropdown:
                cafm.forms.dropdown.setup(me, parent, t);
                break;
            case cafm.enums.SelectType.MultiSelect:
                cafm.forms.multiSelect.setup({
                    select: me,
                    parent: parent
                });
                break;
        }
    });
    return this;
}
$.fn.setupComboBoxes = function (parent) {
    this.each(function () {
        var me = $(this);
        cafm.forms.comboBox.setup({
            wrapper: me,
            parent: parent
        });
    });
    return this;
}
$.fn.setupEvents = function (o) {
    /// <summary>Sets up events on the elements. The events are defined in data attributes. Currently focus, blur, change, and click are supported</summary>
    /// <param name="o" type="Object">Options object</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function () {
        var me = $(this);
        var evs = [
            { event: 'focus.cf', func: me.attr('data-onfocus') },
            { event: 'blur.cf', func: me.attr('data-onblur') },
            { event: 'change.cf', func: me.attr('data-onchange') },
            { event: 'click.cf', func: me.attr('data-onclick') }
        ];
        evs.forEach(function (i) {
            if (i.func) {
                me.off(i.event).on(i.event, function (e) {
                    cafm.handlers.exe(i.func, e)
                });
            }
        });
    });
    return this;
}
$.fn.setupElementState = function () {
    this.each(function () {
        var me = $(this);
        var key = me.data('key');
        var state = key ? cafm.cache.get(key) : null;

        var targetElement = $('#{0}'.format(me.data('target')));
        targetElement.attr('data-targetof', me.attr('id'));

        if (state == null) {
            if (!me.data('expanded')) {
                targetElement.hide();
            }
        }
        else {
            if (!state) {
                targetElement.hide();
                me.attr('data-expanded', false);
            }
            else {
                me.attr('data-expanded', true);
            }
        }

        if ($(me.data('descriptiontarget')).length) {
            if (!me.data('expanded')) {
                setTimeout(function () {
                    cafm.forms.elementState.setDescription(me);
                }, 1000);
            }
        }

        me.click(function () {

            var descTarget = $(me.data('descriptiontarget'));

            if (!me.attr('data-expanded') || me.attr('data-expanded') == 'false') {
                targetElement.slideDown('fast', function () {
                    var expandTxt = me.data('expandedtext');
                    if (descTarget.length || expandTxt) {
                        me.html(expandTxt);
                    }
                    me.attr('data-expanded', true);
                    targetElement.focus();

                    var descEl = $('.elementStateDesc', me);
                    if (descEl.length) {
                        descEl.remove();
                    }

                    if (key) {
                        cafm.cache.set(key, 1);
                    }
                    cafm.forms.elementState.fireCollapseStateChanged(me, true);
                });
            }
            else {
                targetElement.slideUp('fast', function () {
                    if (descTarget.length) {
                        var collapseTxt = me.data('collapsedtext');
                        me.html(collapseTxt);
                    }
                    me.removeAttr('data-expanded');
                    me.blur();
                    if (descTarget.length) {
                        cafm.forms.elementState.setDescription(me);
                    }

                    if (key) {
                        cafm.cache.set(key, 0);
                    }
                    cafm.forms.elementState.fireCollapseStateChanged(me, false);
                });
            }
        });
    });
}
$.fn.setupMakeCall = function () {
    /// <summary>Sets up tel calling functionality on the input text box</summary>
    /// <returns type="$">Returns the JQuery element(s)</returns>

    this.each(function () {

        var me = $(this),
            parent = me.parent(),
            tbox = parent.find('input.cfControl');

        setTimeout(function () {
            me.css('height', tbox.outerHeight() + 'px')
            me.css('top', tbox.position().top + 'px')
        }, 100);

        function setLink() {

            var tel = cafm.util.toTelLink(tbox.val());

            if (tel) {

                me.attr('href', tel);
            }
            else {

                me.removeAttr('href');
            }
        }

        setLink();

        me.click(function () {

            setLink();
        });

        if (!isTouch) {

            parent.hover(function () {

                parent.find('.btn').css('visibility', 'visible');
            }, function () {

                parent.find('.btn').css('visibility', 'hidden');
            });
        }
    });
    return this;
}
$.fn.setupMailTo = function () {
    /// <summary>Sets up email mailto functionality on the input text box</summary>
    /// <returns type="$">Returns the JQuery element(s)</returns>

    this.each(function () {

        var me = $(this),
            parent = me.parent(),
            tbox = parent.find('input.cfEmailInput');

        setTimeout(function () {
            me.css('height', tbox.outerHeight() + 'px')
            me.css('top', tbox.position().top + 'px')
        }, 100);

        function setLink() {

            var mailTo = cafm.util.toMailToLink(tbox.val());

            if (mailTo) {

                me.attr('href', mailTo);
            }
            else {

                me.removeAttr('href');
            }
        }

        setLink();

        me.click(function () {

            setLink();
        });

        if (!isTouch) {

            parent.hover(function () {

                parent.find('.btn').css('visibility', 'visible');
            }, function () {

                parent.find('.btn').css('visibility', 'hidden');
            });
        }
    });
    return this;
}
$.fn.ensureDataLocalityId = function (l) {
    /// <summary>Ensures the element has a location or company id set on a data-locality attribute.</summary>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function (i, el) {

        var me = $(el);
        var locId;

        if (l) {

            var p;
            if (me.hasClass('cfLookup')) {

                p = me.data('path');
            }
            else if (me.hasClass('cfLookupInput')) {

                p = me.closest('.cfLookup').data('path');
            }

            if (p && p == 'Lookup/StandardWorkOrder' && l.BuildingID) {

                locId = l.BuildingID;
            }
        }

        if (!locId && l && l.LocationID) {

            locId = l.LocationID;
        }
        else if (!locId) {

            locId = cafm.auth.companyId();
        }
        me.attr('data-localityid', locId);
        me.data('localityid', locId);
    });
    return this;
}
$.fn.changeVal = function (v, e) {
    /// <summary>Sets the value of the element and fires the onchange event as stored in the data-onchange attribute for the element.</summary>
    /// <param name="v" type="Object">The value</param>
    /// <param name="e" type="Object">The optional event to passthrough</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function () {
        var el = $(this);
        el.val(v);
        el.triggerChange(v, e);
    });
    return this;
}
$.fn.triggerChange = function (v, e) {
    /// <summary>Fires the change event and events stored in the data attributes for the element.</summary>
    /// <param name="v" type="Object">The value</param>
    /// <param name="e" type="Object">The optional event to passthrough</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function () {
        var el = $(this);
        el.trigger('change');

        var oc = el.data('onchange');
        if (oc) {
            cafm.handlers.exe(oc, { target: el, val: v, event: e });
            return;
        }
        var acc = el.data('autocompletechange');
        if (acc) {
            cafm.handlers.exe(acc, { target: el, val: v, event: e });
            return;
        }
        var lc = el.data('lookupchange');
        if (lc) {
            cafm.handlers.exe(lc, { target: el, val: v, event: e });
            return;
        }
    });
    return this;
}
$.fn.clearVal = function (triggerChange) {
    /// <summary>Clears the value of an element</summary>
    /// <param name="triggerChange" type="Boolean">Trigger change event?</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function () {
        var el = $(this);
        el.val('');
        el.html('');
        if (triggerChange) {

            el.trigger('change');
        }
    });
}
$.fn.textVal = function () {

    if (!this.length) {
        return null;
    }

    if (['span', 'li'].indexOf(this[0].tagName.toLowerCase()) > -1) {
        return this.text();
    }

    var plc = this.attr('placeholder');
    var val = this.attr('type') == 'checkbox' ? this.prop('checked') ? cafm.res.str.TextYes : cafm.res.str.TextNo : this.val();
    return val != plc ? val : '';
}
$.fn.setupCheckbox = function () {
    /// <summary>Wraps a check box element with a cafm themed graphical version.</summary>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function (i, chk) {

        chk = $(chk);

        // stop if the checkbox has already been setup
        if (chk.hasClass('chk')) return;

        // check for checkbox client ID and apply to wrap if present
        if (chk.data('chkid')) {

            chk.attr('id', chk.data('chkid'));
        }
    });
    return this;
}
$.fn.toggleCheckbox = function () {
    /// <summary>Toggles the CAFM themed checkbox programatically.</summary>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function (i, chk) {
        chk = $(chk);
        var checked = chk.isChecked();
        chk.setChecked(!checked);
    });
}
$.fn.setChecked = function (checked, suppressChangeEvent) {
    /// <summary>Sets the CAFM themed checkbox programatically.</summary>
    /// <param name="checked" type="Boolean">The checked value</param>
    /// <param name="suppressChangeEvent" type="Boolean">Flag determining whether to suppress the change event or not</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function (i, chk) {
        checked = (typeof (checked) == 'string' && checked == 'true') || checked;
        chk = $(chk);
        let chkBox;
        if (chk.attr('type') == 'checkbox') {
            chkBox = chk;
        }
        else {
            chkBox = chk.closestField().find('[type=checkbox]');
        }
        chkBox.attr('aria-checked', checked);
        chkBox.attr('checked', checked);
        chkBox.prop('checked', checked);
        if (!suppressChangeEvent) {
            chkBox.trigger('change');
        }
    });

    return this;
}
$.fn.isChecked = function () {
    /// <summary>Determines if the checkbox field is checked.</summary>
    /// <returns type="Boolean">Returns the checked state</returns>

    var chkBox;
    if (this.attr('type') == 'checkbox') {
        chkBox = this;
    }
    else {
        chkBox = this.closestField().find('[type=checkbox]');
    }

    return chkBox.prop('checked');
}
$.fn.isCheckboxDisabled = function () {
    /// <summary>Determines if the wrapped CAFM checkbox is disabled or not</summary>
    /// <returns type="Boolean">Returns the disabled state</returns>

    if (this.attr('type') == 'checkbox') {
        return this.prop('disabled');
    }
    else {
        return this.closestField().find('[type=checkbox]').prop('disabled');
    }
}
$.fn.setCheckboxDisabled = function (disabled) {

    this.each(function (i, chk) {
        var chk = $(chk);
        if (chk.attr('type') == 'checkbox') {
            chkBox = chk;
        }
        else {
            chkBox = chk.closestField().find('[type=checkbox]');
        }

        if (disabled) {
            chkBox.prop('disabled', true);
        }
        else {
            chkBox.removeAttr('disabled');
        }
    });

    return this;
}
$.fn.setupTriStateCheckbox = function () {
    /// <summary>Wraps a check box element with a cafm themed graphical version.</summary>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function (i, input) {
        input = $(input);

        // first wrap checkbox with span and replace the checkbox
        var wrap = $('<span/>', {
            'class': 'triChk',
            html: '&nbsp;'
        });
        input.hide();
        wrap.insertBefore(input);
        wrap.data('input', input);
        input.data('wrap', wrap);

        // add label click handler if there is one linked to the checkbox
        var lbl = $('label[for="' + input.attr('id') + '"]');
        if (lbl.length) {
            $(lbl).click(function () {
                wrap.click();
                return false;
            });
        }

        // set initial check 'view' state
        wrap.setTriCheckedState(parseInt(input.val()), true);

        // add change handler
        wrap.click(function (e) {
            wrap.toggleTriCheckbox();
        });
    });
    return this;
}
$.fn.setTriCheckedState = function (value, suppressChangeEvent) {
    /// <summary>Sets the CAFM themed tri-checkbox programatically.</summary>
    /// <param name="value" type="Integer">The check state value</param>
    /// <param name="suppressChangeEvent" type="Boolean">Flag determining whether to suppress the change event or not</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function (i, wrap) {

        wrap = $(wrap);
        wrap.removeClass('triChecked triEither');

        if (isStr(value)) {

            value = parseInt(value);
        }

        switch (value) {

            case cafm.enums.DefaultableBooleanData.True:

                wrap.addClass('triChecked');
                break;

            case cafm.enums.DefaultableBooleanData.Either:

                wrap.addClass('triEither');
                break;
        }

        var input = wrap.data('input');

        if (suppressChangeEvent) {
            input.val(value);
        }
        else {
            input.changeVal(value);
        }
    });
}
$.fn.toggleTriCheckbox = function () {
    /// <summary>Toggles the CAFM themed tri-checkbox programatically.</summary>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function (i, wrap) {

        wrap = $(wrap);
        var input = wrap.data('input');
        var v = input.val()
        if (!v) {
            v = cafm.enums.DefaultableBooleanData.Unspecified;
        }
        else if (isStr(v)) {
            v = parseInt(v);
        }
        switch (v) {

            case cafm.enums.DefaultableBooleanData.Unspecified:
            case cafm.enums.DefaultableBooleanData.False:

                wrap.setTriCheckedState(cafm.enums.DefaultableBooleanData.True);
                break;

            case cafm.enums.DefaultableBooleanData.True:

                wrap.setTriCheckedState(cafm.enums.DefaultableBooleanData.Either);
                break;

            case cafm.enums.DefaultableBooleanData.Either:

                wrap.setTriCheckedState(cafm.enums.DefaultableBooleanData.False);
                break;
        }
    });
}
$.fn.setupListSelectors = function (parent) {
    this.each(function () {
        cafm.forms.listSelector.setup($(this), parent);
    });
}
$.fn.enterPressed = function (func) {
    /// <summary>Attaches an enter pressed handler onto the element(s)</summary>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function () {
        var el = $(this);
        el.bind('keypress.ep', function (e) {

            var kp = e.keyCode ? e.keyCode : e.charCode;
            if (kp == 13) {

                if (cafm.browsers.isEdge()) {

                    cafm.util.callFunctionAsync({
                        func: func,
                        arg1: e,
                        timeout: 50
                    })
                }
                else {

                    return func(e);
                }
            }
        });
    });
    return this;
}
$.fn.submitClick = function (options) {
    /// <summary>Ensures an element can be clicked only once</summary>
    /// <param name="options" type="String">The options, encapsulates the function to call after the first click only</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>
    this.each(function () {
        if (!options.Func) return;
        var clickTar = jQuery(this);
        clickTar.click(function () {
            clickTar.attr('disabled', 'true');
            try {
                return options.Func();
            }
            catch (err) { }
            clickTar.attr('disabled', 'false');
        });
    });
    return this;
}
$.fn.checkForCapsLock = function (onCb, offCb) {
    /// <summary>Hooks up the on keyup event for the element to detect if caps lock is on</summary>
    /// <param name="onCb" type="function">The callback function for when caps lock is on</param>
    /// <param name="offCb" type="function">The callback function for when caps lock is off</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    if (!onCb) return;
    this.each(function () {
        var t = jQuery(this);
        t.off('keyup.caps').on('keyup.caps', function (e) {
            var cc = e.keyCode ? e.keyCode : e.charCode;
            var shifton = false;
            if (e.shiftKey)
                shifton = e.shiftKey;
            else if (e.modifiers)
                shifton = !!(e.modifiers & 4);

            // stop execution if this press is not a-z or caps lock
            if (!((cc >= 65 && cc <= 90) || cc == 20))
                return;
            else if (window.capsOn && cc == 20) {
                delete window.capsOn;
                if (isFunc(offCb)) offCb();
                return;
            }

            var isOn;
            var t = $(e.target);
            var v = t.val();
            var c;
            if (v) {
                var i = cafm.util.getCaretPosition(e.target);
                c = v.split('')[i - 1];
            }
            // check the char is the same as just typed, if not return as not interested - handles full textboxes
            if (cc != 20 && (c && (c.toUpperCase() != String.fromCharCode(cc) || v.length == t.attr('maxLength')))) return;
            isOn = c && ((c == c.toUpperCase() && !shifton) || (c == c.toLowerCase() && shifton));

            if (isOn && isFunc(onCb)) {
                if (!window.capsOn) onCb();
                window.capsOn = true;
            }
            else {
                delete window.capsOn;
                if (isFunc(offCb)) offCb();
                return;
            }
        });
    });
    return this;
}
$.fn.getBoundFieldName = function () {
    /// <summary>Gets the bound field name</summary>

    var b = this.data('bind');
    var fName;
    if (b)
        fName = b.split(':')[1].trim();
    return fName;
}
$.fn.getCustomBoundFieldName = function () {
    /// <summary>Gets the custom bound field name</summary>

    var b = this.data('custombind');
    var fName;
    if (b && b.indexOf(':') > -1) {
        fName = b.split(':')[1].trim();
    }
    else {
        fName = b;
    }
    return fName;
}
$.fn.sortSelect = function () {
    this.each(function () {
        var lb = $(this);
        var items = $("option", lb);
        items.sort(function (a, b) {
            if (a.text < b.text) return -1;
            if (a.text == b.text) return 0;
            return 1;
        });
        items.remove();
        lb.append(items);
    });
}
$.fn.sortChildrenByText = function () {

    this.each(function () {
        var me = $(this);
        var children = me.children();
        children.sort(function (a, b) {
            var aTxt = $(a).text().toLowerCase();
            var bTxt = $(b).text().toLowerCase();
            if (aTxt < bTxt) return -1;
            if (aTxt == bTxt) return 0;
            return 1;
        });
        children.remove();
        me.append(children);
    });
}
$.fn.formatInnerValue = function () {

    this.each(function (e) {

        var me = $(this);
        var formatter = me.data('formatter');
        if (formatter) {

            if (!me.data('originalValue')) {

                me.data('originalValue', me.html());
            }
            else {

                me.html(me.data('originalValue'));
            }

            var formatted = cafm.util.callFunction(formatter, me);

            if (isJQuery(formatted)) {

                me.html('').append(formatted);
            }
            else {

                me.html(formatted);
            }
        }
    });
}
$.fn.clearFormattedInnerValues = function () {

    this.find('.cfRoValSpan[data-formatter]').each(function (e) {

        $(this).removeData('originalValue').text('');
    });
}
$.fn.getDatePickers = function () {

    var datePickers = [];
    this.each(function (e, wrapper) {

        $('.k-datepicker .cfControl', wrapper).each(function (i, el) {

            var c = $(el).data('kendoDatePicker');
            datePickers.push(c ? c : $(el));
        });
    });
    return datePickers;
}
$.fn.getDateTimePickers = function () {

    var dateTimePickers = [];
    this.each(function (e, wrapper) {

        $('.k-datetimepicker .cfControl[data-dtkind="utc"]', wrapper).each(function (i, el) {

            var c = $(el).data('kendoDateTimePicker');
            dateTimePickers.push(c ? c : $(el));
        });
    });
    return dateTimePickers;
}
$.fn.getTimePickers = function () {

    var timePickers = [];
    this.each(function (e, wrapper) {

        $('.k-timepicker .cfControl', wrapper).each(function (i, el) {

            var c = $(el).data('kendoTimePicker');
            timePickers.push(c ? c : $(el));
        });
    });
    return timePickers;
}

$.fn.getLookups = function () {

    var lookups = [];
    this.each(function (e, wrapper) {

        $('.cfLookup', e).each(function (i, el) {

            lookups.push($(el));
        });
    });
    return lookups;
}
$.fn.getDropdowns = function () {

    var dropdowns = [];
    this.each(function (e, wrapper) {

        $('.k-dropdown .cfControl', wrapper).each(function (i, el) {

            var c = $(el).data('kendoDropDownList');
            dropdowns.push(c ? c : $(el));
        });
    });
    return dropdowns;
}
$.fn.getComboBoxes = function () {

    var combos = [];
    this.each(function (e, wrapper) {

        $('.k-combobox .cfControl', wrapper).not('.k-input').each(function (i, el) {

            var c = $(el).data('kendoComboBox');
            combos.push(c ? c : $(el));
        });
    });
    return combos;
}
$.fn.getMultiSelects = function () {

    var multiSelects = [];
    this.each(function (e, wrapper) {

        $('.k-multiselect .cfControl', wrapper).each(function (i, el) {

            multiSelects.push($(el).data('kendoMultiSelect'));
        });
    });
    return multiSelects;
}
$.fn.getCheckboxes = function () {

    var checkboxes = [];
    this.each(function (e, wrapper) {

        $('.cfChk', wrapper).each(function (i, el) {

            checkboxes.push($(el));
        });
    });
    return checkboxes;
}
$.fn.getTextboxes = function () {

    var textboxes = [];
    this.each(function (e, wrapper) {

        $('.k-numerictextbox,.cfTextInput', wrapper).each(function (i, el) {

            textboxes.push($(el));
        });
    });
    return textboxes;
}
$.fn.getNumericTextboxes = function () {

    var numerics = [];
    this.each(function (e, wrapper) {

        $('.k-numerictextbox .cfControl[data-role="numerictextbox"]', wrapper).each(function (i, el) {

            numerics.push($(el).data('kendoNumericTextBox'));
        });
    });
    return numerics;
}

$.fn.enableControls = function (enabled) {
    /// <summary>Enable/disable form controls within the matched element(s)</summary>
    /// <param name="enabled" type="Boolean">True for enabled, false for disabled</param>
    /// <returns type="$">Returns jQuery matched element(s)</returns>

    var disabled = !enabled;
    this.each(function (i, el) {

        var form = $(el);
        form.find('.cfTextInput,.cfTextArea,input[type="radio"]').prop('disabled', disabled);
        form.find('.checklist-fields input[type="checkbox"]').setCheckboxDisabled(disabled);

        var controls = [];
        cafm.util.addAll(controls, form.getDatePickers());
        cafm.util.addAll(controls, form.getDateTimePickers());
        cafm.util.addAll(controls, form.getTimePickers());
        cafm.util.addAll(controls, form.getTextboxes());
        cafm.util.addAll(controls, form.getNumericTextboxes());

        controls.forEach(function (control) {

            if (isFunc(control.enable)) {
                control.enable(enabled);
            }
            else if (isJQuery(control)) {
                control.prop('disabled', disabled);
            }
        });
    })

    return this;
}

$.fn.ensureInvalidFieldsAreVisible = function () {

    $('[data-targetof]', this).each(function () {

        if ($('.k-invalid', this).length) {

            var collapsible = $(this);

            if (collapsible.css('display') == 'none') {

                var targetOf = collapsible.data('targetof');
                $('#' + targetOf).click();
            }
        }
    });
}
$.fn.touchHold = function (handler, minHold) {

    $(this).kendoTouch({
        minHold: isUndefined(minHold) ? 1000 : minHold,
        hold: function (e) {

            handler(e.event);
        }
    });

    return this;
}
$.fn.touchTap = function () {

    var handler;
    var childSelector;

    if (arguments.length == 2) {

        childSelector = arguments[0];
        handler = arguments[1];
    }
    else {

        handler = arguments[0];
    }

    this.each(function (i, el) {

        el = $(el);

        var startEvents, endEvents;

        // need to handle ie desktop touch events differently
        if (cafm.browsers.isIe()) {

            startEvents = 'mousedown touchstart MSPointerDown';
            endEvents = 'mouseup touchend MSPointerUp';
        }
        else {

            startEvents = 'touchstart MSPointerDown';
            endEvents = 'touchend MSPointerUp';
        }

        el.on(startEvents, childSelector, function (e) {

            if ($(e.target).hasClass('cLink')) {

                return;
            }
            $(e.currentTarget).data('touchstart', cafm.util.getTime());
        });

        el.on(endEvents, childSelector, function (e) {

            if ($(e.target).hasClass('cLink')) {

                return;
            }
            var targ = $(e.currentTarget);
            var ts = targ.data('touchstart');
            var tdiff = cafm.util.getTime() - parseInt(ts);

            if (tdiff < 75) {

                handler(e);
            }
            targ.removeData('touchstart');
        });
    });
}

$.fn.prepareMultiSelect = function (kms) {

    $(this).each(function (i, el) {

        el = $(el);

        kms.input.off('focus.cafm').on('focus.cafm', function (e) {

            var eventsApplied = kms.wrapper.data('cafmEventsApplied');

            if (!eventsApplied) {

                if (isMobile) {

                    kms.input.attr('readonly', true);
                }

                kms.bind('open', function (ev) {

                    kms.wrapper.addClass('cfMultiSelectOpen');
                });

                kms.bind('close', function (ev) {

                    kms.wrapper.removeClass('cfMultiSelectOpen');
                });

                kms.bind('change', function (ev) {

                    kms.wrapper.setMultiSelectText();
                });

                kms.wrapper.on('touchend MSPointerUp', '.k-button', function (ev) {

                    var targ = $(ev.currentTarget);
                    if (!targ.hasClass('k-delete')) {

                        targ.find('.k-delete').click();
                        return false;
                    }
                });

                kms.wrapper.data('cafmEventsApplied', true);
            }

            kms.open();
        });

        kms.input.off('blur.cafm').on('blur.cafm', function (e) {

            kms.close();
        });

        el.find('.k-multiselect').setMultiSelectText();
    });
}
$.fn.setMultiSelectText = function () {

    var mc = $(this);
    var buttons = mc.find('.k-button');
    var mt = mc.find('.multiSelectTxt');
    var txt;

    if (buttons.length > 1) {

        txt = cafm.res.str.TextMultiple;
    }
    else {

        txt = buttons.first().find('span:first').text();
    }

    if (!mt.length) {

        $('<span />', {

            'class': 'multiSelectTxt cText',
            text: txt
        }).prependTo(mc);
    }
    else {

        mt.text(txt);
    }
}

$.fn.setupBasicList = function (e) {

    $(this).each(function (i, el) {

        var o = {
            listTarget: $(el)
        }

        if (e) {

            o.onRemove = e.onRemove;
            o.dataItem = e.dataItem;
            o.forceSetup = e.forceSetup;
        }

        cafm.forms.basicList.setup(o);
    });
}
$.fn.getBasicListItems = function () {

    var el = $(this);

    if (!el.hasClass('simpleList')) {

        el = el.find('.simpleList');
    }

    return el.data('items');
}
$.fn.getBasicListDescription = function () {

    var items = $(this).getBasicListItems();

    if (cafm.util.hasItem(items)) {

        return items.length > 1 ? cafm.res.str.TextMultiple : items[0].text;
    }
    else {

        return '';
    }
}
$.fn.getParentWindowElement = function () {

    return $('.k-window-content', $(this).parents('.k-window:first'));
}
$.fn.getParentWindow = function () {

    return $(this).getParentWindowElement().data('kendoWindow');
}
$.fn.ensureDefaultValues = function () {

    this.each(function (i, el) {

        el = $(el);

        if (!el.text() && el.data('default')) {

            el.text(el.data('default'));
        }
    });
}
$.fn.enableLookup = function () {
    /// <summary>Enables the lookup element(s), element must be the wrapper with cfLookup class</summary>
    /// <returns type="$">Returns the JQuery element(s)</returns>

    this.each(function (i, el) {

        $(el).removeAttr('data-disabled').find('.cfLookupInput').removeAttr('disabled').parents('.cfLookup:first').setupLookup();
    });

    return this;
}
$.fn.enableNumeric = function (enabled) {

    $(this).each(function (i, el) {

        el = $(el);

        if (!el.attr('data-bind')) {

            el = el.find('[data-bind]');
        }

        el.removeAttr('disabled');

        var numeric = el.data('kendoNumericTextBox');
        if (numeric) {

            numeric.enable(enabled);
        }
    });
}

$.fn.disableLookup = function () {
    /// <summary>Disables the lookup element(s), element must be the wrapper with cfLookup class</summary>
    /// <returns type="$">Returns the JQuery element(s)</returns>


    this.each(function (i, el) {

        var element = $(el);
        element.find('.cfLookup').attr('data-disabled', true).find('.cfLookupInput').prop('disabled', true).closest('.cfLookup').setupLookup();
        element.getDropdowns().forEach(function (kdl) {
            kdl.enable(false);
        })
    });

    return this;
}

$.fn.setupWindow = function (dataItem) {
    /// <summary>Sets up an element with window opening functionality based on data-win attributes</summary>
    /// <param type="Object">Optional data item to format the URL string with</param>
    /// <returns type="$">The matched form element(s)</returns>

    this.each(function (i, el) {

        var element = $(el);

        if (!element.data('win-url')) return false;

        var doIt = function (dataItem, element) {

            var data = element.data();
            cafm.views.openActionWindow({
                url: cafm.url.get(dataItem ? data.winUrl.dataFormat(dataItem) : data.winUrl),
                initialText: cafm.res.str.TextPreparingForm,
                winOptions: {
                    width: cafm.views.actionWindowConfig[data.winWidth || 'large'].width(),
                    height: data.winMinHeight ? null : cafm.views.actionWindowConfig[data.winHeight || 'large'].height(),
                    minHeight: data.winMinHeight,
                    title: data.winTitle
                },
                onInit: data.winInit,
                onLoad: data.winLoad,
                closeOnOverlayClick: data.winCloseOnOverlayClick
            });
            return false;
        }

        element.off('click.cafm').on('click.cafm', function (e) { doIt(dataItem, $(e.currentTarget)); });
    })
}

$.fn.closestField = function () {
    /// <summary>Gets the closest field element</summary>
    /// <returns type="$">The matched form element(s)</returns>

    return this.closest('.cfField');
}

/**
 * Ensures an input has a disabled auto complete attribute, includes a workaround for Google Chrome.
 * @return {$} Returns the matched jQuery element(s)
 */
$.fn.ensureDisabledAutoComplete = function () {

    this.each(function (i, el) {
        let tbox = $(el), autoc = tbox.attr('autocomplete');
        if (!autoc || autoc === 'on') {
            if (cafm.browsers.isChrome() || cafm.browsers.isChromeMobile()) {
                tbox.attr('autocomplete', cafm.guid.newGuid());
            }
            else {
                tbox.attr('autocomplete', 'off');
            }
        }
    });
    return this;
}

cafm.forms = {
    dropdown: {
        setup: function (me, parent, dt) {

            var data = me.data(), opts = {
                dataTextField: data.textField,
                dataValueField: data.valueField,
                change: function (args) {

                    var kDdl = args.sender,
                        element = kDdl.element,
                        viewModel = element.getParentViewModel(),
                        fieldName = element.getDataBoundFieldName(),
                        value = cafm.util.getReference(fieldName, viewModel);

                    if (viewModel && isObj(value) && fieldName) {

                        cafm.util.setProperty(viewModel, fieldName, kDdl.value());
                    }
                    if (data.action && element.closestField().parent().hasClass('cFilter') && fieldName.endsWith('ID')) {

                        var descFieldName = fieldName.substr(0, fieldName.length - 2) + 'Description';
                        if (isDefined(viewModel.get(descFieldName)))
                            viewModel.set(descFieldName, kDdl.text());
                    }
                }
            }

            var items = data.items, lid = data.localityid;

            if (data.action) {

                opts.dataSource = {

                    transport: {

                        read: function (options) {

                            var crit = $(me[0]).getCriteria(),
                                lid = me.data().localityid;

                            if (lid) {

                                if (!crit) crit = {};

                                crit.LocationID = lid;
                            };

                            // get the data by executing the action
                            cafm.actions.execute({
                                url: cafm.url.get(data.action),
                                method: data.method,
                                values: crit,
                                statusCodeFuncs: {

                                    200: function (response) {

                                        options.success(response);
                                    }
                                },
                                error: function (response) {

                                    options.error(response);
                                }
                            });
                        }
                    }
                }

                opts.autoBind = data.autobind;

                if (lid) {

                    opts.open = function (args) {

                        var nowLid = me.data().localityid
                        if (lid != nowLid) {

                            lid = nowLid;
                            var kDdl = args.sender;
                            kDdl.dataSource.data([]);
                            kDdl.dataSource.read();
                        }
                    }
                }
            }
            else if (items) {

                opts.dataSource = items;

                if (lid && lid != cafm.guid.empty) {

                    opts.dataSource = cafm.util.filterItemsByLocationId(opts.dataSource, lid);
                }
            }

            var txt = data.initialtext;
            if (txt) {
                opts.optionLabel = txt;
            }

            var kdl = me.kendoDropDownList(opts).data().kendoDropDownList;

            if (cafm.browsers.isIeMobile() || cafm.browsers.isEdgeMobile()) {

                ieMobile.fixKendoDropdown({

                    widget: kdl
                });
            }
            else if (cafm.browsers.isBbMobile()) {

                bbMobile.fixKendoDropdown({

                    widget: kdl
                });
            }

            var v = data.value;
            if (items && !(isNullOrUndefined(v) || v === '')) {
                cafm.util.callFunctionAsync({
                    func: function () {
                        kdl.value(v);
                        // CAFM-5722: for reports - trigger change event
                        var vm = kdl.element.getParentViewModel();
                        var fld = kdl.element.getBoundFieldName();
                        if (vm && vm[fld]) {
                            kdl.trigger('change');
                        }
                        
                    }, timeout: 100
                });
            }
        }
    },
    multiSelect: {

        setup: function (e) {

            var select = e.select;

            var opts = {
                autoClose: false,
                dataSource: select.data('items'),
                dataTextField: select.data('text-field'),
                dataValueField: select.data('value-field'),
                valuePrimitive: true
            }

            var noneTxt = select.data('initialtext');
            if (!noneTxt) noneTxt = cafm.res.str.TextNone;

            var kms = select.kendoMultiSelect(opts).data('kendoMultiSelect');

            kms.bind('open', function (e) {
                $('.k-item', e.sender.popup.element).addClass('k-state-noshow');
            });

            var v = select.data('value');
            if (v) {
                kms.value(v);
            }

            var fieldWrapper = select.closest('.cfMultiSelect');
            if (!fieldWrapper.hasClass('static-multi-select')) {

                fieldWrapper.prepareMultiSelect(kms);
                // CAFM-5722: for reports - push default value onto UI and trigger change event
                if (v) {
                    cafm.util.callFunctionAsync({
                        func: function () {
                            var vm = select.getParentViewModel();
                            var fld = select.getBoundFieldName();
                            if (vm && vm[fld]) {
                                vm.set(select.getBoundFieldName(), { value: v });
                                kms.trigger('change')
                                select.closest('.cfMultiSelect').setMultiSelectText();
                            }
                        }, timeout: 100
                    });
                }
            }
        }
    },
    listSelector: {
        setSelected: function (parent, lst) {
            var vm = parent.getViewModel();
            var val = vm.get(lst.getCustomBoundFieldName());
            if (val) {
                if (cafm.forms.listSelector.isEnumItem(lst)) {
                    cafm.forms.listSelector.setEnumValue(lst, val);
                } else {
                    for (var i = 0; i < val.length; i++) {
                        $("input[data-value=" + val[i] + "]", lst).attr('checked', true);
                    }
                }
            }
        },
        setup: function (me, parent) {
            var me = $('> ul', me),
                fieldName = me.getCustomBoundFieldName(),
                items = me.data('items');

            me.kendoListView({
                dataSource: {
                    data: items
                },
                template: kendo.template($('#checkboxListTemplate').html())
            });
            me.find(':checkbox').each(function (i, c) {
                c = $(c);
                var id = '{0}_{1}'.format(fieldName.replace(/\./g, '_'), c.data('value'));
                c.attr('id', id);
                c.siblings('.k-checkbox-label').attr('for', id);
                c.change(function () {
                    cafm.forms.listSelector.setVMVal(parent, me);
                });
            });
        },
        ensureMin: function (lst) {
            if (cafm.util.isTrue(lst.data('isrequired'))) {
                var reqValue = lst.data('requiredvalue');
                if (cafm.forms.listSelector.isEnumItem(lst)) {
                    var enumVal = cafm.forms.listSelector.getEnumValue(lst);
                    if (isUndefined(enumVal)) {
                        cafm.forms.listSelector.setEnumValue(lst, reqValue);
                    }
                } else {
                    var itemVal = cafm.forms.listSelector.getSelected(lst);
                    if (itemVal == []) {
                        $("input[data-value=" + reqValue + "]", lst).attr('checked', true);
                    }
                }
            }
        },
        getEnumValue: function (lst) {
            var eValue;
            $(lst).find(':checkbox').each(function (i, e) {
                var cb = $(e);
                var cValue = cb.data('value');
                if (cb.is(':checked')) {
                    if (i == 0) {
                        eValue = cValue;
                    } else {
                        eValue = eValue | cValue;
                    }
                }
            });
            return eValue;
        },
        setEnumValue: function (lst, val) {
            if (val) {
                $(lst).find(':checkbox').each(function (i, e) {
                    var cb = $(e);
                    var cValue = parseInt(cb.data('value'));
                    cb.attr('checked', (val & cValue) === cValue);
                });
            }
        },
        isEnumItem: function (lst) {
            var enumItem = lst.data('enum');
            return enumItem && enumItem.toLowerCase() === 'true';
        },
        getSelected: function (lst) {
            if (cafm.forms.listSelector.isEnumItem(lst)) {
                return cafm.forms.listSelector.getEnumValue(lst);
            }
            var controlValue = [];
            $(lst).find(':checkbox').each(function (i, e) {
                var cb = $(e);
                var cValue = cb.data('value');
                if (cb.is(':checked')) {
                    controlValue.push(cValue);
                }
            });
            return controlValue;
        },
        setVMVal: function (parent, lst) {
            cafm.forms.listSelector.ensureMin(lst);
            var vm = parent.getViewModel();
            var fn = lst.getCustomBoundFieldName();
            if (vm) {
                var controlVal = cafm.forms.listSelector.getSelected(lst);
                vm.set(fn, controlVal);
            }
        }
    },
    comboBox: {

        setup: function (e) {

            var w = e.wrapper; // the combobox wrapper
            var t = $('input.cfControl', w).not('.k-input'); // the combobox target element
            var ds = t.data('datasource');
            var resolvedDs;

            if (ds && isStr(ds)) {
                ds = cafm.util.getReference(ds);
            }

            if (!ds) {

                resolvedDs = {
                    transport: {
                        read: t.data('datasourceurlpath')
                    }
                };
            }
            else if (isFunc(ds)) {

                resolvedDs = ds(e);
            }

            var onchange = t.data('onchange');
            var onopen = t.data('onopen');
            var onkeyup = t.data('onkeyup');

            var combo = t.kendoComboBox({
                autoBind: t.data('autobind'),
                suggest: t.data('suggest'),
                placeholder: t.data('placeholder'),
                dataTextField: t.data('text-field'),
                dataValueField: t.data('value-field'),
                dataSource: resolvedDs,
                change: onchange ? cafm.util.getReference(onchange) : null,
                open: onopen ? cafm.util.getReference(onopen) : null,
                highlightFirst: false,
                clearButton: false,
                noDataTemplate: ''
            }).data('kendoComboBox');

            if (cafm.browsers.isIeMobile() || cafm.browsers.isEdgeMobile()) {

                ieMobile.fixKendoComboBox({

                    widget: combo
                });
            }
            else if (cafm.browsers.isBbMobile()) {

                bbMobile.fixKendoComboBox({

                    widget: combo
                });
            }

            if (onkeyup) {

                combo.input.on('input', cafm.util.getReference(onkeyup));
            }
        }
    },
    basicList: {

        itemTemplate: function () {
            return kendo.template('<li class="simpleListItem" data-value="#=value#"#if(data.required){# data-required="${required}"#}#>#=text# #if(!data.required){#<img class="simpleListItemRemove" src="' +
                cafm.url.get('Content/Themes/Default/icons/grey/1061-remove-16.png') +
                '" alt="x" title=\"Remove field\" />#}#</li>')
        },

        setup: function (e) {

            if (e.listTarget.data('setup') && isUndefined(e.forceSetup)) {

                return;
            }

            e.listTarget.off('click').on('click', 'li', function (ev) {

                // get the list item element
                var item = $(ev.target);
                if (!item.hasClass('simpleListItem')) {
                    item = item.parent();
                }
                var list = item.parents('.simpleList:first');

                var targId = e.listTarget.data('target');

                if (targId || e.listTarget.data('removeable')) {

                    if (!item.data('required')) {

                        // remove the list item element from list
                        cafm.forms.basicList.remove({
                            listTarget: list,
                            onRemove: e.onRemove
                        }, item);

                        if (targId) {

                            var targetList = $('#' + targId);
                            cafm.forms.basicList.add({

                                listTarget: targetList,
                                dataItem: {
                                    value: item.data('value'),
                                    text: item.text()
                                }
                            });
                        }
                    }
                }

                var ph = e.listTarget.data('itempressed');
                if (ph) {

                    cafm.util.callFunction(ph, ev);
                }

                return false;
            });

            e.listTarget.data('setup', true);

            if (cafm.util.hasItem(e.dataItem)) {

                cafm.forms.basicList.add({

                    listTarget: e.listTarget,
                    dataItem: e.dataItem
                });
            }
        },
        populateItems: function (listTarget, items) {

            // remove existing items
            listTarget.remove('.simpleListItem');

            // add the provided items to the list
            cafm.forms.basicList.add({
                listTarget: listTarget,
                dataItem: items,
                suppressEvent: true
            });
        },
        add: function (e) {

            var lt = e.listTarget;

            if (!lt.data('setup')) {

                cafm.forms.basicList.setup(e);
            }

            // get the existing data
            var persistData = lt.attr('data-items');
            if (!persistData) {

                persistData = [];
            }
            else if (isStr(persistData)) {

                persistData = JSON.parse(persistData);
            }
            else if (isFunc(persistData.toJSON)) {

                persistData = persistData.toJSON();
            }

            // append the list item element or multiple if array
            // checks if the item is already in the list or not
            if (isArray(e.dataItem)) {

                e.dataItem.forEach(function (i) {

                    if (!cafm.forms.basicList.hasItem({ listTarget: lt, value: i.value })) {

                        var newItem = $(cafm.forms.basicList.itemTemplate()(i)).appendTo(lt);

                        if (e.itemAttr) {

                            newItem.attr(e.itemAttr);
                        }

                        persistData.push(i);
                    }
                });
            }
            else {

                if (e.dataItem.value && e.dataItem.value != cafm.guid.empty && !cafm.forms.basicList.hasItem({ listTarget: lt, value: e.dataItem.value })) {

                    var newItem = $(cafm.forms.basicList.itemTemplate()(e.dataItem)).appendTo(lt);

                    if (e.itemAttr) {

                        newItem.attr(e.itemAttr);
                    }

                    persistData.push(e.dataItem);
                }
            }

            // sort the list by text
            lt.sortChildrenByText();

            // store the items again
            lt.data('items', persistData);
            lt.attr('data-items', JSON.stringify(persistData));

            // trigger change event of the list element
            if (!e.suppressEvent) {
                lt.trigger('change');
            }

            if (lt.hasClass('cfLookupList')) {

                cafm.forms.basicList.updateLookup(e);
            }
        },
        clear: function (e) {

            var lt = e.listTarget;
            lt.children('.simpleListItem').remove();
            lt.removeAttr('data-items');
            lt.removeData('items');

            if (e.hideAfterClear) {

                lt.hide();
            }

            // trigger change event of the list element
            if (!e.suppressEvent) {

                lt.trigger('change');
            }

            if (lt.hasClass('cfLookupList')) {

                cafm.forms.basicList.updateLookup(e);
            }
        },
        hasItem: function (e) {

            return e.listTarget.children('.simpleListItem[data-value="{0}"]'.format(e.value)).length > 0;
        },
        remove: function (e, item) {

            var lt = e.listTarget;

            // get the existing data
            var persistData = lt.attr('data-items');
            if (!persistData) {

                persistData = [];
            }
            else if (isStr(persistData)) {

                persistData = JSON.parse(persistData);
            }
            else if (isFunc(persistData.toJSON)) {

                persistData = persistData.toJSON();
            }

            function doRemove(theItem) {

                var itemValue = isJQuery(theItem) ? theItem.data('value') : theItem.value;
                var itemText = isJQuery(theItem) ? theItem.text() : theItem.text;

                // remove the data item
                cafm.util.removeWhere(persistData, function (pd) {

                    return pd.value == itemValue;
                });

                // store the items again
                lt.attr('data-items', JSON.stringify(persistData));

                // refresh data items
                lt.data('items', persistData);

                // remove the list item element
                lt.children('.simpleListItem[data-value="{0}"]'.format(itemValue)).remove();

                var source = lt.data('source');
                if (source) {

                    var sourceList = $('#' + source);
                    cafm.forms.basicList.add({

                        listTarget: sourceList,
                        dataItem: {

                            value: itemValue,
                            text: itemText
                        }
                    });
                }
            }

            if (isArray(item)) {

                $.each(item, function (i, anItem) {

                    doRemove(anItem);
                });
            }
            else {

                doRemove(item);
            }

            // trigger change event of the list element
            if (!e.suppressEvent) {
                lt.trigger('change');
            }

            // call custom remove event if there is one
            if (isFunc(e.onRemove)) {

                e.onRemove({
                    listTarget: lt,
                    item: item
                });
            }

            if (lt.hasClass('cfLookupList')) {

                cafm.forms.basicList.updateLookup(e);
            }
        },
        updateLookup: function (e) {

            var lt = e.listTarget;
            var lu = lt.parents('.cfLookup:first');
            var txt = lu.find('.cfLookupInput');

            var bld = lt.getBasicListDescription();

            if (bld) {

                txt.val(bld).attr('title', bld);
            }
            else {

                txt.val('').attr('title', '');
            }
        }
    },
    elementState: {

        setDescription: function (me) {

            var descTarget = $(me.data('descriptiontarget'));

            var desc;
            if (descTarget.length == 1) {
                desc = descTarget.textVal();
            }
            else {
                desc = '';
                descTarget.each(function (i, el) {
                    var item = $(el);
                    var val = item.textVal();
                    if (val) {
                        if (desc) {
                            desc += ', ';
                        }
                        desc += val;
                    }
                });
            }

            if (desc) {
                var descEl = $('.elementStateDesc', me);
                if (!descEl.length) {

                    descEl = $('<span />', {
                        'class': 'elementStateDesc'
                    }).appendTo(me);
                }
                descEl.html('&nbsp;({0})'.format(desc));
            }
            else {
                $('.elementStateDesc', me).remove();
            }
        },
        fireCollapseStateChanged: function (me) {

            if (me.data('collapsestatechanged')) {

                cafm.util.callFunction(me.data('collapsestatechanged'), me);
            }
        }
    },
    handlers: {

        formTabChanged: function (e, afterTabChange) {
            /// <summary>Method to handle work order tab selected event</summary>
            /// <param name="e" type="Object">Tab selected event args object</param>
            /// <param name="afterTabChange" type="Function">After tab change handler function</param>

            var item = $(e.item);
            var key = item.data('key');
            var action = item.data('action');
            var value = item.data('value');
            var value2 = item.data('value2');
            var ce = $(e.contentElement);
            var isForm = ce.data('isform');
            var widget = e.sender.element;
            var alwaysLoad = widget.data('alwaysload');
            var singleLoad = widget.data('singleload');
            var postData = widget.data('postdata');

            cafm.forms.selectTabKey = key;

            var loadedTabKeys = cafm.util.isTrue(alwaysLoad) ? [] : widget.data('loadedTabKeys');

            if (action && value && action.indexOf('{value}') > -1) {

                action = action.replace('{value}', value);
            }
            if (action && value2 && action.indexOf('{value2}') > -1) {

                action = action.replace('{value2}', value2);
            }

            if (action && !isArray(loadedTabKeys)) {

                loadedTabKeys = [];
                widget.data('loadedTabKeys', loadedTabKeys);
            }

            if (action && $.inArray(key, loadedTabKeys) < 0) {

                var targ = e.contentElement ? $(e.contentElement) : $('.k-content:first', e.item);

                if (cafm.util.isTrue(singleLoad)) {

                    var contentEls = widget.find('> .k-content');
                    kendo.destroy(contentEls.children());
                    contentEls.html('');
                }

                targ.loadView({
                    url: cafm.url.get(action),
                    method: postData ? 'POST' : 'GET',
                    values: postData,
                    isForm: isForm,
                    onLoad: function (taskElement) {

                        // page form tabs handler
                        cafm.handlers.exe('cafm.forms.afterFormTabChanged', taskElement);

                        // on the fly handler, useful for action windows to keep the handlers separate
                        cafm.util.callFunction(afterTabChange);

                        // workaround for tabstrip issue where the 2 tabs can be visible at once
                        if (!isMobile && e.sender.element.hasClass(cafm.res.consts.ElementId_FormWidget)) {

                            cafm.util.callFunctionAsync({
                                func: function () {
                                    var tabs = $('#{0} > .k-content'.format(cafm.res.consts.ElementId_FormWidget));
                                    tabs.not('[data-key="{0}"]'.format(cafm.forms.selectTabKey)).hide();
                                    var tab = tabs.filter('[data-key="{0}"]'.format(cafm.forms.selectTabKey));
                                    if (!tab.is(':visible')) tab.show();
                                }
                            });
                        }
                    }
                });

                if (loadedTabKeys) {

                    loadedTabKeys.push(key);
                }
            }
            else {

                if (ce.css('opacity') != 1) ce.css({ opacity: 1 });

                setTimeout(function () {

                    // page form tabs handler
                    cafm.handlers.exe('cafm.forms.afterFormTabChanged');

                    // on the fly handler, useful for action windows to keep the handlers separate
                    cafm.util.callFunction(afterTabChange);
                }, 200);
            }
        }
    },
    checkForRemovables: function () {

        // bypass this if offline
        if (cafm.isOffline() || cafm.enablingPermissibleFeatures) {

            return;
        }

        var listWrappers;
        if (isMobile) {
            listWrappers = $('#{0} .k-state-active .k-content .cLvWrap'.format(cafm.res.consts.ElementId_MainForm));
        }
        else {
            listWrappers = $('#{0} .k-content.k-state-active .cLvWrap'.format(cafm.res.consts.ElementId_MainForm));
        }

        var deleteBtns = $('button[data-key="Remove"]', listWrappers),
            activeDataKey = cafm.forms.getActiveFormSection(),
            activeFormCategorySelector = '.k-content[data-key="{0}"]'.format(activeDataKey),
            activeFormCategory = $(activeFormCategorySelector);

        if (listWrappers.length && (activeFormCategory.length || isMobile) && deleteBtns.length) {

            listWrappers.each(function (i, el) {

                var listWrapper = $(el);

                // add remove selected function
                var addRemoveItem = function () {

                    var lh = $('.cLvHead', listWrapper), remBtn = $('button[data-key="Remove"]', lh);

                    remBtn.show();

                    if (!isMobile) {

                        activeFormCategory = $(activeFormCategorySelector);

                        // ensure the category is open in the tree
                        //if (!activeFormCategory.hasClass('tvActive')) activeFormCategory.click();

                        //var removeItem = $('.tvItem[data-key="RemoveSelected"]', activeFormCategory);

                        //if (!removeItem.length) {

                        //    var kNavTree = nav.getKendoNavTree();
                        //    var newItem = kNavTree.append({
                        //        text: cafm.res.str.ToolbarLabelRemoveSelected,
                        //        imageUrl: cafm.url.get('Content/Themes/Default/icons/grey/1054-clear-16.png')
                        //    }, activeFormCategory);
                        //    newItem.attr('id', remBtn.attr('id')).attr('data-itemtype', cafm.enums.TreeViewItemType.FormAction).attr('data-key', 'RemoveSelected').addClass('tvItem');
                        //    remBtn.removeAttr('id');
                        //}
                    }

                    if (cafm.forms.hasVisibleButton(lh)) {

                        lh.show();
                    }
                }

                // hide remove selected handler
                var hideRemoveItem = function () {

                    var lh = $('.cLvHead', listWrapper), remBtn = $('button[data-key="Remove"]', lh);
                    remBtn.hide();

                    if (isMobile) {

                        if (!cafm.forms.hasVisibleButton(lh)) {
                            lh.hide();
                        }
                    }
                    else {

                        activeFormCategory = $(activeFormCategorySelector);
                        var removeItem = $('.tvItem[data-key="RemoveSelected"]', activeFormCategory);
                        if (removeItem.length) {

                            if (removeItem.attr('id')) {
                                remBtn.attr('id', removeItem.attr('id'));
                            }

                            var kNavTree = nav.getKendoNavTree();
                            kNavTree.remove(removeItem);
                        }
                    }
                }

                if (!listWrapper.data('RemoveableEventAttached')) {

                    var selectedItems,
                        listView = listWrapper.getLv(),
                        onListChange = function (e) {

                            selectedItems = listWrappers.getListSelectedDataItems();
                            if (!selectedItems || !selectedItems.length) {

                                hideRemoveItem();
                            }
                            else {

                                addRemoveItem();
                            }
                        };

                    if (!listView) {

                        var setChangeEvent = function () {

                            var listView = listWrapper.getLv();

                            if (!listView) {

                                setTimeout(setChangeEvent, 500);
                            }
                            else {

                                listView.bind('change', onListChange);
                            }
                        }
                        setTimeout(setChangeEvent, 500);
                    }
                    else {

                        listView.bind('change', onListChange);
                    }

                    listWrapper.data('RemoveableEventAttached', true);
                }

                selectedItems = listWrappers.getListSelectedDataItems();
                if (!selectedItems || !selectedItems.length) {

                    hideRemoveItem();
                }
                else {

                    addRemoveItem();
                }
            });
        }
        else {

            listWrappers.each(function (i, el) {

                var listWrapper = $(el),
                    lh = $('.cLvHead', listWrapper);

                // hide the toolbar if no actions are available
                if (isMobile && !cafm.forms.hasVisibleButton(lh)) {

                    lh.hide();
                }
            });
        }
    },
    ensureDataLocalityId: function (locality, parent) {

        if (isNullOrUndefined(parent)) {

            parent = body;
        }

        $('[data-localityid]', parent).ensureDataLocalityId(locality);
    },
    getActiveFormSection: function () {

        return forms.getActiveFormSectionElement().data('key');
    },
    getActiveFormSectionElement: function () {

        if (isMobile) {

            return $('#{0} > .k-state-active[data-key]'.format(cafm.res.consts.ElementId_FormWidget));
        }
        else {

            return $('#{0} > .k-tabstrip-items > .k-state-active[data-key]'.format(cafm.res.consts.ElementId_FormWidget));
        }
    },
    hasVisibleButton: function (c) {

        var hvb = false;
        $('button', c).each(function (i, bel) {

            if ($(bel).css('display') != 'none') {
                hvb = true; // has visible button
                return false; // break loop
            }
        });

        return hvb;
    },
    isActiveFormSection: function (dataKey) {

        return (isMobile && $('li.k-state-active[data-key="{0}"]'.format(dataKey)).length) || (!isMobile && $('div.k-state-active[data-key="{0}"]'.format(dataKey)).length);
    },
    openFormSection: function (dataKey) {

        if (isMobile) {

            $('#{0} > li[data-key="{1}"] > .k-link'.format(cafm.res.consts.ElementId_FormWidget, dataKey)).click();
        }
        else {

            $('#{0} > ul > li[data-key="{1}"] > .k-link'.format(cafm.res.consts.ElementId_FormWidget, dataKey)).click();
        }
    },
    setMainFormLoadedKeys: function (keys) {

        var mfw = cafm.views.getMainFormWidget();

        if (mfw) {

            mfw.data('loadedTabKeys', keys);
        }
    },
    placeMainFormToolbar: function () {

        var fbPlc = $('#formButtonsPlc');
        var toRemove = $('.cTb', fbPlc);

        if (toRemove.length) {

            toRemove.remove();
        }

        var woTb = $('.mainToolbar:first');
        woTb.hide().detach().appendTo(fbPlc).fadeIn();

        if (cafm.nav.router) {

            cafm.nav.router.onRouteChanged(function () {
                cafm.forms.removeMainFormToolbar();
            });
        }
    },
    removeMainFormToolbar: function () {

        var wot = $('.mainToolbar:first');
        wot.fadeOut(function () {
            wot.remove();
        });
    },
    showFormSection: function (index, isLoad) {

        if (!isNum(index)) {

            index = 0;
        }

        let widget = $('#' + cafm.res.consts.ElementId_FormWidget), dk;

        if (!widget) return;

        if (!isMobile && isLoad) {
            let kts = widget.data('kendoTabStrip');
            if (kts) kts.select(0);
        }
        else {
            let target = isMobile ? widget : widget.find("> .k-tabstrip-items");
            //$('> .k-item:eq({0})'.format(index), target).click();
            dk = $('> .k-item:eq({0})'.format(index), target).data('key');
            target.find(`> .k-item[data-key="${dk}"] > .k-link`).click();
        }
    },
    switchFormPanel: function (e) {

        var key = e.item.data('key');
        var toCollapse = $('> [data-expanded]', e.item.parent()).not('.tvItem[data-key="Actions"]');
        e.tree.collapse(toCollapse);
        e.tree.expand(e.item);
        $('#{0} .k-tabstrip-items [data-key="{1}"]'.format(cafm.res.consts.ElementId_FormWidget, key)).click();
    },
    helpers: {
        determineLocality: function () {

            var locality;
            if (cafm.nav.isNav(cafm.enums.Navigatable.HelpdeskNewWorkOrder, cafm.enums.Navigatable.HelpdeskEditWorkOrder) && cafm.hd.workOrder) {

                locality = cafm.hd.workOrder.LocalityDescription;
            }
            else if (cafm.nav.navigatable && cafm.enums.getEnumKey(cafm.enums.Navigatable, cafm.nav.navigatable).startsWith('Helpdesk')) {

                locality = null;
            }
            else if (cafm.nav.isNav(cafm.enums.Navigatable.RoomBookingRoomSearch, cafm.enums.Navigatable.RoomBookingEditBooking)) {

                var roomBooking = cafm.views.getMainFormViewModel();
                locality = roomBooking.LocalityDescription;
            }
            else if (cafm.nav.navigatable == cafm.enums.Navigatable.RoomBookingCalendar) {

                var viewModel = cafm.rb.scheduler.getRoomCriteria();

                if (isNullOrUndefined(viewModel)) {

                    viewModel = cafm.views.getMainFormViewModel();

                    if (viewModel) {

                        locality = viewModel.LocalityDescription;
                    }
                    else {

                        locality = null;
                    }
                }
                else {

                    locality = {
                        LocationID: cafm.util.getItemValue(viewModel.LocalityID)
                    };
                }
            }
            else {

                locality = cafm.hi.getCurrentLocality();
            }

            return locality;
        },
        generateFieldValidationElement: function (e) {

            return $('<span/>', {

                id: e.elementId,
                'class': 'k-widget k-tooltip k-tooltip-validation k-invalid-msg',
                html: '<span class="k-icon k-i-warning"></span>' + e.message
            });
        },
        /**
         * Fires when User changes the session DateTime value of the DateTime control. This then updates the counterpart UTC control bound to VM.
         * @param {any} e
         */
        onChangeOfSessionDateTime: function (e) {
            var sender = e.target;
            var wrapper = $(sender).closest('[id^=dtWrapper]');
            var kind = $(sender).data('dtkind');
            if (kind == 'local') {
                var dtTxt = $(sender).val();
                if (dtTxt) {
                    var dm;
                    var cs = cafm.getClientSettings();
                    dm = moment(dtTxt, cs.dateTimeMomentPattern);

                    var dtUtc = cafm.web.funcs.fromSessionToUTCDateTime(dm.toDate());
                    var utcCtr = wrapper.find('.cfControl[data-dtkind="utc"]');
                    var vm = utcCtr.getParentViewModel();
                    if (vm) {
                        $(sender).data('session_dt_changing', 1);//Set flag to indicate we are changing session value. Then reset the flag when VM is bound to UTC control
                        vm.set(utcCtr.getBoundFieldName(), dtUtc);
                        $(utcCtr).triggerChange();
                    }
                }
            }
        },
        /**
         * Fires when User changes the session Date value of the DateFromWithUTC control. This then updates the counterpart UTC control bound to VM.
         * @param {any} e
         */
        onChangeOfSessionDateFrom: function (e) {
            cafm.forms.helpers.onChangeOfSessionDateTimeFromTo(e, false);
        },
        /**
         * Fires when User changes the session Date value of the DateToWithUTC control. This then updates the counterpart UTC control bound to VM.
         * @param {any} e
         */
        onChangeOfSessionDateTo: function (e) {
            cafm.forms.helpers.onChangeOfSessionDateTimeFromTo(e, true);
        },
        onChangeOfSessionDateTimeFromTo: function (e, isToDate) {
            var expectedDtKind = isToDate ? "to-utc" : "from-utc";
            var sender = e.target;
            var wrapper = $(sender).closest('[id^=dtWrapper]');
            var kind = $(sender).data('dtkind');
            if (kind == 'local') {
                var dtTxt = $(sender).val();
                if (dtTxt) {
                    let fmt = isMobile ? "YYYY-MM-DDT00:00.0" : cafm.util.browserDateFormat() + " 00:00" //"DD/MM/YYYY 00:00";
                    let dm = moment(dtTxt, fmt);

                    let tzName = $(sender).data('currentTimeZone') || cafm.cache.session.get(cafm.res.consts.CacheKey_TimeZone);

                    if (isToDate) {
                        dm.add(1, 'd').subtract(1, 'ms');    //move to end of day - NOT as below in case clocks forward on that day!
                                                            //dm.add(23, 'h').add(59, 'm').add(59, 's').add(9, 'ms');
                    }
                    var dtUtc = cafm.web.funcs.fromSessionToUTCDateTime(dm.toDate(), !isToDate, tzName);
                    var utcCtr = wrapper.find(`.cfControl[data-dtkind="${expectedDtKind}"]`);
                    var vm = utcCtr.getParentViewModel();
                    if (vm) {
                        var dtIso = `${moment(dtUtc).format("YYYY-MM-DDTHH:mm:ss.000")}Z`;
                        vm.set(utcCtr.getBoundFieldName(), dtIso);
                    }
                }
            }
        }
    }
}
var forms = cafm.forms;